import React from 'react';

const CheckboxComponent = ({ options, accordionIndex, onCheckboxChange }) => {
  return (
    <div className="ds-accordion__content" id={`accordion-Date-${accordionIndex}`}>
      <fieldset className="ds-fe-fieldset">
        <div className="ds-fe-checkboxes">
          {options.map((option, checkboxIndex) => (
            <label key={checkboxIndex} className="ds-fe-checkboxes__container">
              {option.name ? option.name : <span>None</span>}
              <input
                className="ds-fe-checkboxes__input"
                checked={option.checked}
                value={option}
                type="checkbox"
                onChange={() => onCheckboxChange(accordionIndex, checkboxIndex)}
              />
              <span className="ds-fe-checkboxes__checkmark">
                <svg className="ds-fe-checkboxes__icon">
                  <use href="#ds-general-checkmark"></use>
                </svg>
              </span>
            </label>
          ))}
        </div>
      </fieldset>
    </div>
  );
};

export default CheckboxComponent;